export const FILTER_TYPES = ['jobs', 'members', 'audit-log', 'cleanup-tasks',
// Not currently used but kept to keep dashboard code from HUB
'dashboard'];
export const FILTER_TYPES_TO_PERMISSIONS = {
  // customers: 'Customer',
  // interactions: 'Interaction',
  // products: 'Product',
};